module.exports = __webpack_public_path__ + "img/cover5.71de38c9.jpeg";